







import Vue from 'vue';
import Component from 'vue-class-component';
import { Breadcrumbs, PageTitle } from '@questelservices/common-vue';
import ClientAgentsFeeSheets from '../components/fee-sheets/client-agents-fee-sheets.vue';

@Component({
  components: {
    Breadcrumbs,
    PageTitle,
    ClientAgentsFeeSheets
  }
})
export default class FeeSheets extends Vue {}
